import * as React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import LP from './screens/LP';
import Auth from './screens/Auth';
import OuterApp from './screens/OuterApp';
import Signup from './screens/Signup';
import Logout from './modules/app/Logout';
import ErrorPage from './screens/ErrorPage';
import EventPage from './screens/EventPage';
import Main from './screens/Main';
import Dashboard from './screens/Dashboard';
import AuthedEventPage from './modules/app/AuthedEventPage';
import AuthedTicketPage from './modules/app/AuthedTicketPage';
import ShowTickets from './modules/app/ShowTickets';
import OurStory from './screens/OurStory';
import LPEvents from './screens/LPEvents';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import CreateEvent from './screens/CreateEvent';
import EventManager from './modules/eventManager/EventMgr';
import { ForgotPassword } from './screens/ForgotPw';
import { HandleForgotPw } from './screens/HandleForgotPw';
import PrivacyPolicy from './screens/PrivacyPolicy';
import { ContactUs } from './modules/lp/ContactUs';
import ToS from './screens/ToS';
import Test from './screens/Test';
import VerifyCode from './screens/VerifyCode';
import AdminDashboard from './modules/app/admin/AdminDashboard';
import UserSettings from './modules/app/admin/user/UserSettings';
import TicketResults from './screens/TicketResults';
import FreeTickets from './modules/checkout/FreeTicketResults';
import UserMain from './modules/settings/Main';
import OLGRedirect from './screens/OLGRedirect';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <App><ErrorPage /></App>,
    children: [
      {
        index: true,
        element: <LP />
      },
      {
        path: 'events',
        element: <LPEvents />
      },
      {
        path: "events/:slug",
        element: <EventPage />
      },
      {
        path: "our-long-goodbye",
        element: <OLGRedirect />
      },
      {
        path: "our-story",
        element: <OurStory />
      },
      {
        path: 'create-event',
        element: <CreateEvent />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />
      },
      {
        path: 'contact-us',
        element: <ContactUs />
      },
      {
        path: 'tos',
        element: <ToS />
      },
      {
        path: 'test',
        element: <Test />
      }
    ]
  },
  {
    path: "/signup",
    element: <OuterApp><Signup /></OuterApp>
  },
  {
    path: "/verify",
    element: <OuterApp><VerifyCode /></OuterApp>
  },
  {
    path: "/login",
    element: <OuterApp><Auth /></OuterApp>
  },
  {
    path: "/forgot-password",
    element: <OuterApp><ForgotPassword /></OuterApp>
  },
  {
    path: "/forgot-password/:code",
    element: <OuterApp><HandleForgotPw /></OuterApp>
  },
  {
    path: "/logout",
    element: <OuterApp><Logout /></OuterApp>
  },
  {
    path: "/tickets",
    element: <OuterApp><TicketResults /></OuterApp>
  },
  {
    path: "/tickets/free",
    element: <OuterApp><FreeTickets /></OuterApp>
  },
  {
    path: "/app",
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "dashboard",
        element: <Dashboard />
      },
      {
        path: "settings",
        element: <UserMain />
      },
      {
        path: 'events',
        element: <AuthedEventPage />
      },
      {
        path: 'create-event',
        element: <CreateEvent />
      },
      {
        path: 'tickets',
        element: <AuthedTicketPage />
      },
      {
        path: "events/:id",
        element: <EventManager />
      },
      {
        path: "tickets/:id",
        element: <ShowTickets />
      },
      {
        path: "admin",
        element: <AdminDashboard />
      },
      {
        path: "admin/users/:id",
        element: <UserSettings />
      }
    ]
  }
]);

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} /> 
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals(console.log);
